import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Frontend crash caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 text-white bg-red-600">
          ⚠️ Something broke. Refresh the page.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;